import React from 'react'
import { CircularProgress, Paper, Typography } from '@material-ui/core'
import { useTranslation } from '@/langs/useTranslation'
import { FormItem } from '@/components/Form'
import { TextInput } from './Compo'

const SupportCenter = ({ value, onChange, loading }) => {
  const { t } = useTranslation()

  return (
    <Paper elevation={0} style={{ backgroundColor: "#F8F9FC", borderRadius: "10px", marginTop: 24 }}>
      <Typography variant="h5" style={{marginBottom: 24}}>
        4. {t({ defaultMessage: "支援中心" })}
        {loading && <CircularProgress size={22} style={{marginLeft: 16}} />}
      </Typography>
      <TextInput
        number="4.1"
        title={t({defaultMessage: "网址中心"})}
        value={value.text}
        name="supportCenter.text"
        placeholder={t({defaultMessage: "例：https://nubiscloud.freshdesk.com/support/home"})}
        onChange={onChange}
        disabled={loading}
      />
    </Paper>
  )
}

export default SupportCenter